import { Outlet } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider, App } from "antd";
import { ErrorBoundary } from "@/components/common/ErrorBoundary";
import zhTW from "antd/locale/zh_TW";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

/**
 * Root Layout
 * Wraps all routes with global providers
 *
 * Providers:
 * - QueryClientProvider: React Query for server state
 * - ConfigProvider: Ant Design configuration (locale, theme)
 * - App: Ant Design App component (required for message, modal, notification APIs)
 * - ErrorBoundary: Catch and display errors gracefully
 */
export default function RootLayout() {
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider locale={zhTW}>
        <App>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </App>
      </ConfigProvider>
    </QueryClientProvider>
  );
}
